<template>
  <card class="addresses-display">
    <template #header>
      <span class="card__title flex flex-middle gap-m">
        <span>
          {{ translate("justopp.address.pageTitle") }}
        </span>
        <icon-halo
          v-if="!isCreatingAddress"
          v-tooltip="{ content: 'justopp.address.addAddressTitle' }"
          class="cursor-pointer"
          icon="plus"
          halo-theme="success"
          theme="bg"
          :size="0.9"
          @click="isCreatingAddress = true"></icon-halo>
      </span>
    </template>
    <template #default>
      <spinner v-if="asyncStatus.asyncDataLoading"></spinner>
      <h3 v-if="!asyncStatus.asyncDataLoading && (!addresses || addresses.length < 1)">
        {{ translateUcFirst("justopp.address.noAddressesFound") }}
      </h3>
      <div v-if="isEditingAddress" class="panel margin-l-bottom">
        <div class="flex gap-m flex-middle margin-l-bottom">
          <icon-halo
            v-if="isEditingAddress"
            v-tooltip="{ content: 'justopp.address.cancelAddAddressTooltip' }"
            class="cursor-pointer"
            halo-theme="danger"
            theme="bg"
            icon="x"
            @click="isEditingAddress = false"></icon-halo>
          <h6 class="margin-remove">
            {{ translateUcFirst("justopp.address.editAddressTitle") }}
          </h6>
        </div>

        <base-form
          v-model="editAddressData"
          :action="`ecommerce/address/${editAddressData.id}`"
          method="patch"
          form-path="entity/address/create"
          @form:submit-success="addressEditSuccessHandler"></base-form>
      </div>

      <create-user-address-modal
        :opened="isCreatingAddress"
        @modal:closed="isCreatingAddress = false"
        @create-address:success="addressCreatedHandler"
      ></create-user-address-modal>
      <!--
      <div v-if="isCreatingAddress" class="panel margin-l-bottom">
        <div class="flex gap-m flex-middle margin-l-bottom">
          <icon-halo
            v-if="isCreatingAddress"
            v-tooltip="{ content: 'justopp.address.cancelAddAddressTooltip' }"
            class="cursor-pointer"
            halo-theme="danger"
            theme="bg"
            icon="x"
            @click="isCreatingAddress = false"></icon-halo>
          <h6 class="margin-remove">
            {{ translateUcFirst("justopp.address.editAddressTitle") }}
          </h6>
        </div>

        <base-form
          v-model="newAddressData"
          action="ecommerce/address"
          method="post"
          form-path="entity/address/create"
          @form:submit-success="addressCreatedHandler"></base-form>
      </div>
     -->
      <div
        v-if="!asyncStatus.asyncDataLoading"
        class="addresses-display flex flex-start flex-break-center flex-wrap gap-xl">
        <panel
          v-for="address in addresses"
          size="s"
          style="max-width: 300px"
          :auto-translate="false">
          <template #title>
            <icon-halo
              theme="bg"
              halo-theme="lead"
              icon="pencil"
              size="1"
              class="cursor-pointer"
              @click="editAddress(address)"></icon-halo>
            <h4 class="panel__title margin-m-bottom text-l text-overflow-ellipsis">
              {{ address.note }}
            </h4>
          </template>
          <template #default>
            <span class="block margin-m-bottom">{{ address.addressString }}</span
            ><br />
            <div v-for="key of addressFieldsToShow" class="address-item margin-m-bottom">
              <span class="text-s" style="font-weight: 600"
                >{{ translateUcFirst(`ecommerce.address.fields.${key}`) }}:</span
              ><br />
              <span>{{ address[key] && address[key] !== "" ? address[key] : "-" }}</span>
            </div>
            <div class="margin-m-top flex-column gap-m">
              <form-button
                class="width-expand"
                icon="trash"
                theme="danger"
                text="justopp.address.deleteCta"
                @click="deleteAddress(address)"></form-button>
              <form-button
                class="width-expand"
                icon="pencil"
                theme="inverse"
                text="justopp.address.editCta"
                @click="editAddress(address)"></form-button>
            </div>
          </template>
        </panel>
      </div>
    </template>
  </card>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import CreateUserAddressModal from "@/client/components/ecommerce/address/CreateUserAddressModal";
export default {
  name: "Addresses",
  isCreatingAddress: true,
  components: {CreateUserAddressModal},
  layout: {
    component: "UserDashboardInner",
    params: {
      title: "justopp.address.pageTitle",
      subTitle: "justopp.address.pageSubtitle",
      backButton: false,
    },
  },
  meta: "justopp.address.browserTitle",
  middleware: {
    requireUser: {},
  },
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  data: function () {
    return {
      addressFieldsToShow: [
        "note",
        "streetAddress",
        "city",
        "stateProvince",
        "zipCode",
        "country",
      ],
      isCreatingAddress: false,
      isEditingAddress: false,
      editAddressData: {},
      newAddressData: {},
      addresses: false,
      asyncData: {
        addresses: {
          target: "ecommerce/address",
          data: {
            userId: this.$store.getters["user/profile"].id,
          },
          options: {
            dataMutator: (data, result) => {
              if (data.items) {
                return data.items;
              }

              return [];
            },
          },
        },
      },
    };
  },
  methods: {
    editAddress(address) {
      this.editAddressData = { ...address };
      this.isEditingAddress = true;
    },
    addressCreatedHandler() {
      console.log('addressCreatedHandler');
      this.newAddressData = {};
      this.isCreatingAddress = false;
      this.refreshAsyncData();
    },
    addressEditSuccessHandler() {
      this.isEditingAddress = false;
      this.$s.ui.notification("core.successGeneric", "success");
      this.refreshAsyncData();
    },
    deleteAddress(address) {
      this.$s.ui.modal
        .confirm("justopp.address.confirmDeleteText")
        .then(async () => {
          let res = await this.asyncOps.asyncCall(
            "ecommerce/address",
            { ids: [address.id] },
            { method: "delete" }
          );

          if (res.hasError) {
            this.$s.ui.notification("core.errorGeneric", "error");
            return false;
          }

          this.$s.ui.notification("core.successGeneric", "success");
          this.refreshAsyncData();
        })
        .catch((e) => {});
    },
  },
};
</script>

<style></style>
